// extracted by mini-css-extract-plugin
export default {"usersBlock":"Users_usersBlock__dtZEL","user":"Users_user__ureKU","userPhoto":"Users_userPhoto__wCV7+","unfollowBtn":"Users_unfollowBtn__t9DWL","followBtn":"Users_followBtn__CD2Bd"};